/* tslint:disable */
/* eslint-disable */
/**
 * Web API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface FxIdWebFeaturesAuthAuthenticateFromTokenRequest
 */
export interface FxIdWebFeaturesAuthAuthenticateFromTokenRequest {
    /**
     * 
     * @type {string}
     * @memberof FxIdWebFeaturesAuthAuthenticateFromTokenRequest
     */
    TempToken: string;
}

/**
 * Check if a given object implements the FxIdWebFeaturesAuthAuthenticateFromTokenRequest interface.
 */
export function instanceOfFxIdWebFeaturesAuthAuthenticateFromTokenRequest(value: object): value is FxIdWebFeaturesAuthAuthenticateFromTokenRequest {
    if (!('TempToken' in value) || value['TempToken'] === undefined) return false;
    return true;
}

export function FxIdWebFeaturesAuthAuthenticateFromTokenRequestFromJSON(json: any): FxIdWebFeaturesAuthAuthenticateFromTokenRequest {
    return FxIdWebFeaturesAuthAuthenticateFromTokenRequestFromJSONTyped(json, false);
}

export function FxIdWebFeaturesAuthAuthenticateFromTokenRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): FxIdWebFeaturesAuthAuthenticateFromTokenRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'TempToken': json['TempToken'],
    };
}

export function FxIdWebFeaturesAuthAuthenticateFromTokenRequestToJSON(json: any): FxIdWebFeaturesAuthAuthenticateFromTokenRequest {
    return FxIdWebFeaturesAuthAuthenticateFromTokenRequestToJSONTyped(json, false);
}

export function FxIdWebFeaturesAuthAuthenticateFromTokenRequestToJSONTyped(value?: FxIdWebFeaturesAuthAuthenticateFromTokenRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'TempToken': value['TempToken'],
    };
}

